module.exports = __webpack_public_path__ + "img/智慧警务-综合业务中台软件V2.0.c5021850.jpg";